import React from "react";
import { Layout } from "../components/Layout";
import { LotusMark } from "../components/Logo";
import { siteConfig } from "../data/siteConfig";

const sections = [
  {
    title: "Information we collect",
    body: "When you contact us or book a class, we may collect your name, email address, phone number and any details you share about your health or yoga goals so we can serve you safely and well.",
  },
  {
    title: "How we use your information",
    body: "We use your information solely to respond to enquiries, schedule and deliver classes, process bookings, and keep you informed about your sessions. We do not sell your personal information to anyone.",
  },
  {
    title: "Sharing & disclosure",
    body: "We only share information where necessary to deliver our services (for example, secure payment or scheduling tools) or where required by law. Any partners we use are expected to protect your data.",
  },
  {
    title: "Data security",
    body: "We take reasonable measures to protect your personal information. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
  },
  {
    title: "Your choices",
    body: "You may request access to, correction of, or deletion of your personal information at any time by contacting us at the email below.",
  },
];

export const PrivacyPage = () => {
  return (
    <Layout>
      <section className="pt-28 md:pt-32 pb-12">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <LotusMark className="w-10 h-10 mx-auto mb-5" />
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal mb-3">
            Privacy Policy
          </h1>
          <p className="text-charcoal/60">
            How {siteConfig.name} handles your information.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container mx-auto px-6 max-w-3xl space-y-6">
          {sections.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-2xl p-7 border border-accent/15 shadow-soft"
            >
              <h2 className="font-heading text-2xl text-charcoal mb-2">
                {s.title}
              </h2>
              <p className="text-charcoal/75 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <p className="text-sm text-charcoal/60 pt-2">
            Questions about this policy? Email us at{" "}
            <a
              href={`mailto:${siteConfig.email}`}
              className="text-primary font-medium"
            >
              {siteConfig.email}
            </a>
            .
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPage;
